import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import { dataAbout, dataBlockConst } from './tokenDrivers.consts';

TokenDrivers.propTypes = {
    data: PropTypes.array,
};

function TokenDrivers(props) {
    const { data } = props;

    const [dataBlock] = useState(dataBlockConst);

    return (
        <div className="td-main">

            <div className="left-common-div heading-resp" style={{ paddingLeft: "10px", paddingLeft: "30px" }}>
                <div data-aos="fade-right" data-aos-duration="900">
                    <h2 className='f-w-700 text-shadow driver-heading' style={{ color: "white" }}>WHY INVEST IN REM TOKENS?</h2>
                    <div style={{ border: "1px solid #92D050", width: window.innerWidth >1130? "39%" : '100%', margin: "10px 0px 10px 25px" }}></div>
                    <h3 className='f-w-700 text-shadow driver-heading' style={{ color: "white" }}>KEY VALUE PROPOSITIONS:</h3>
                </div>
            </div>

            <div className='img-div'>
                <div className='td-cards-main row'>
                    {dataAbout.map((item, index) => (
                        <div data-aos="fade-left" data-aos-duration="900" key={item.id} className={`${window.innerWidth < 1024 && item.title === '' ? 'col-0' : (window.innerWidth < 1250 ? 'col-12' : 'col-3')}`}>
                            {item.title === "" ? (
                                <div></div>
                            ) : (
                                <div className="driver-card tf-step wow fadeInUp card" data-wow-delay="0.2s">
                                    <div className="card-content">
                                        <div className="step-title">
                                            <div className="sub-number" style={{ position: "relative", top: "7px",opacity: 1, color: "#92D050", fontWeight: "bolder", scale: "0.9", left: "-35%" }}>
                                                0{item.id}
                                            </div>
                                            <h3 style={{ fontWeight: "900" }} className='title-style text-shadow'>{item.title}</h3>
                                        </div>
                                        <p className='responsive-paragraph'>
                                            {/* {item.text.split('\n').map((line, index) => ( */}
                                            {item.text.split('\n').map((line, index) => (
                                                <React.Fragment key={index}>
                                                    {line}
                                                    <br />
                                                </React.Fragment>
                                            ))}
                                        </p>
                                    </div>
                                </div>
                            )}
                        </div>

                    ))}
                </div>
            </div>

        </div>
    );
}
{/* <div style={{ border: "1px solid #92D050", width: "69%", margin: "-3px 0px 0px 25px" }}></div> */ }

export default TokenDrivers;
